import React from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

// import required modules
import { Autoplay, Pagination, Navigation } from "swiper";
import { bannerData } from "../../Datas/PersonalData/bannerData";
const Banner = () => {
  return (
    <div className="w-full  mx-auto h-auto">
      <img
        className="mx-auto mb-10 w-full relative before:absolute before:top-0 before:left-0 before:opacity-20 before:w-full before:h-full before:z-10 before:content-[''] before:bg-black"
        src={
          "https://thanoseshop.com/wp-content/uploads/2022/10/Final-e1655814109297-2048x998.png"
        }
        alt={"All gaming top up in one place"}
      />
    </div>
  );
};

export default Banner;
